<template>
  <div class="app-main-content">
    <customer-recovery-tree-grid v-show="view==='list'" ref="customerRecoveryTreeGrid" no="1" @look="lookHandler" />
    <customer-workspace v-show="view==='detail'" ref="customerWorkspace" :model-type="3" no="2" @back="backToList" />
  </div>
</template>

<script>
import customerRecoveryTreeGrid from './components/crmRecoveryCustomerManager/customerRecoveryTreeGrid'
import customerWorkspace from './components/crm/customerWorkspace'
import lodash from 'lodash'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'CRMRecoveryCustomerManager',
  components: { customerRecoveryTreeGrid, customerWorkspace },
  data() {
    return {
      view: 'list'
    }
  },
  mounted() {
    SalesUtil.checkCrmExpire(this.$route, this.$router)
  },
  methods: {
    lookHandler(row) {
      this.view = 'detail'
      const rowData = lodash.cloneDeep(this.$refs.customerRecoveryTreeGrid.rowData)
      row = rowData.find(p => p.uuid === row.uuid)
      this.$refs.customerWorkspace.onShow('look', rowData, row)
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        const detailUuidSet = new Set()
        for (const item of this.$refs.customerWorkspace.rowData) {
          detailUuidSet.add(item.uuid)
        }
        const removedUuids = []
        for (const item of this.$refs.customerRecoveryTreeGrid.rowData) {
          if (!detailUuidSet.has(item.uuid)) {
            removedUuids.push(item.uuid)
          }
        }
        this.$refs.customerRecoveryTreeGrid.toRemove(removedUuids)
      }
    }
  }
}
</script>
